import axios from 'axios';
import { createRouteQuery } from './queries';

const addRoute = (model) =>
    new Promise((resolve, reject) => {
        const query = createRouteQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add route'));
            });
    });

export default addRoute;
